<script setup>
	import { storeToRefs } from 'pinia';
    import * as http from '@/libs/http';
	import modules from '@/components/design/index.js';
	import { useAppStore } from "@/store/modules/app";
	import storage from '@/libs/storage';
	
	const appStore 	= useAppStore();
    const { site }  = storeToRefs(appStore);
	const isLoading = ref(true);
	const result 	= ref(storage.getJson("pc_home",{list: []}));
	onMounted(()=>{
		http.get("index/index",{ temp_id: "pc" }).then(res=>{
			isLoading.value = false;
			if(res.code == 1){
				result.value.list = [];
				result.value = res.data;
				storage.setJson("pc_home",res.data);
			}
		});

		document.title = site.value.ctitle + " - " + site.value.title;
	});

</script>

<template>
    <layout>
		<template v-for="(item,index) in result.list" :key="index">
			<component :is="modules[item.type]" :data="item.value"></component>
		</template>
	</layout>
</template>

<style lang="scss" scoped>

</style>